import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SEARCH_PROJECT, TOGGLE_SEARCH_INPUT_VISIBILITY } from 'actions';
import { FormControl, TextField } from '@mui/material';

const SearchProjectInput: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const dispatch = useDispatch();
  const isInputVisible = useSelector((state: appState) => state.app.searchInputVisible);
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isInputVisible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isInputVisible]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        if (!searchValue.trim()) {
          dispatch(TOGGLE_SEARCH_INPUT_VISIBILITY(false));
        }
      }
    };

    if (isInputVisible) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isInputVisible, dispatch, searchValue]);

  const handleKeyPress = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setSearchValue('');
      dispatch(SEARCH_PROJECT(searchValue.trim()));
      dispatch(TOGGLE_SEARCH_INPUT_VISIBILITY(false));
    } else if (e.key === 'Escape') {
      setSearchValue('');
      dispatch(TOGGLE_SEARCH_INPUT_VISIBILITY(false));
    }
  }, [searchValue, dispatch]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  }, []);

  const handleTextClick = useCallback(() => {
    dispatch(TOGGLE_SEARCH_INPUT_VISIBILITY(true));
  }, [dispatch]);

  if (!isInputVisible) {
    return (
      <div ref={containerRef} className="search-project-text-options" onClick={handleTextClick}>
        <span className="search-option">SEARCH PROJECT</span>
      </div>
    );
  }

  return (
    <div ref={containerRef}>
      <FormControl>
        <TextField
          inputRef={inputRef}
          id="search-project-input"
          placeholder=""
          variant="standard"
          onKeyDown={handleKeyPress}
          onChange={handleChange}
          value={searchValue}
        />
      </FormControl>
    </div>
  );
};

export default SearchProjectInput;
